import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import App from "./App";
import Diagram from "./components/Diagram/Diagram";
import Resources from "./components/Resources/Resources";
import LoginScreen from "./components/LoginScreen/LoginScreen";
import Reports from "./components/Reports/Reports";
import JournalContent from "./components/Journal/JournalContent";
import Statistics from "./components/Statistics/Statistics";
import Mail from "./components/Mail/Mail";
import NotFound from "./components/NotFound";

function AppRouter() {
	const handleLogin = (role) => {
		localStorage.setItem('userRole', role);
	};

	return (
		<Router>
			<Routes>
				{/* Логин — без шапки */}
				<Route path="/" element={<LoginScreen onLogin={handleLogin} />} />

				{/* Все остальные страницы — внутри Layout (с шапкой top-nav) */}
				<Route element={<Layout />}>
					<Route path="/app" element={<App />} />
					<Route path="/diagram" element={<Diagram />} />
					<Route path="/resources" element={<Resources />} />
					<Route path="/reports" element={<Reports />} />
					<Route path="/journal" element={<JournalContent />} />
					<Route path="/statistics" element={<Statistics />} />
					<Route path="/mail" element={<Mail />} />
					<Route path="*" element={<NotFound />} />
				</Route>
			</Routes>
		</Router>
	);
}

export default AppRouter;